import {useEffect, useRef} from 'react';

// A button above a tab sends 'request' (a counter) to open a box on that tab. The box opens only when the counter
// changes while the tab is shown, not when the tab is shown again after another tab, so the box does not open by
// itself on Restrict Access or User Invitations.
const useOnNewRequest = (request, onRequest) => {
    const seen = useRef(request);
    useEffect(() => {
        if (request && request !== seen.current) {
            onRequest();
        }
        seen.current = request;
    }, [request]);
};

export default useOnNewRequest;
